// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfHour as fn } from "../endOfHour.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfHour = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfHour;
